import {
  AfterViewInit,
  Directive,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { CxTableService } from '../services/cx-table.service';
import { cloneDeep } from 'lodash';
import { CellWidth } from '../cx-datagrid-config';

@Directive({ selector: '[cxColumnFrozen]' })
export class CxColumnFrozenDirective implements OnInit, AfterViewInit {
  @Input() cxColumnFrozen: any = {};
  @Input() cxColumnFrozenIndex = 0;

  constructor(private el: ElementRef, public tableService: CxTableService) {}

  ngAfterViewInit(): void {
    this.setWidthAndLeft();
  }

  ngOnInit(): void {
    this.setWidthAndLeft();
  }

  setWidthAndLeft() {
    if (this.cxColumnFrozen.frozen) {
      this.el.nativeElement.classList.add('frozen-column');
      const columnIndex = this.tableService.columns
        .filter((x: any) => x.frozen && x.display)
        .findIndex((x: any) => x.key === this.cxColumnFrozen.key);
      if (columnIndex > 0) {
        this.tableService.columns[columnIndex].width = this.tableService.columns[columnIndex].width || CellWidth;
      }
      if (columnIndex > -1) {
        if (0 === columnIndex) {
          this.el.nativeElement.style.left = '0px';
        } else {
          if (this.el) {
            let left = cloneDeep(this.tableService.columns)
              .slice(0, columnIndex)
              .map((x) => x.width)
              .reduce((x: any, y: any) => {
                return Number(x) +Number(y);
              }, 0);
            if (columnIndex === 1 && this.tableService.columns[0].selection && this.tableService.columns[0].display) {
              left = 50;
            }
            this.tableService.columns[columnIndex].left = left;
            this.el.nativeElement.style.left = `${left}px`;
          }
        }
      }
    }
  }
}
